import { Input } from "postcss/lib/postcss";
import React from "react";
import { Col, Modal } from "react-bootstrap";
import Select from "react-select";
import InputText from "../../common/Input/InputText";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";

const EditTest = ({
  editTestModal,
  setEditTestModal,
  testFormData,
  handleSubmitUpdateTestDetails,
  handleSetTestFormData,
  handleEditTestModal,
  categories,
  liscodes,
  setInputError,
  testSampleType,
  testMethod,
}) => {
  return (
    <>
      <Modal
        centered
        show={editTestModal}
        onHide={() => setEditTestModal(false)}
        size={"xl"}
      >
        <div className="modal-header">
          <h3 className="modal-title" id="exampleModalLabel">
            Update Test Master
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => handleEditTestModal()}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmitUpdateTestDetails}>
            <div className="row">
              <div className="col-xl-4">
                <InputText
                  name="testName"
                  value={testFormData.testName}
                  onChange={(e) => handleSetTestFormData(e)}
                  placeholder="Test Name"
                  label="Test Name"
                  fieldName="Test Name"
                  setInputTextError={setInputError}
                />
              </div>
              <Col xl={4}>
                <div className="form-group position-relative">
                  <label htmlFor="categories" className="col-form-label">
                    Category Name:
                  </label>
                  {testFormData && (
                    <Select
                      value={{
                        value: testFormData.category,
                        label: testFormData.categoryName,
                      }}
                      placeholder="Select Clinic"
                      onChange={(e) => handleSetTestFormData(e, "category")}
                      options={
                        categories &&
                        categories.map((item) => ({
                          value: item._id,
                          label: item?.categoryName,
                        }))
                      }
                      style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: " 15px",
                      }}
                    />
                  )}
                </div>
              </Col>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Low Range:
                  </label>
                  <input
                    type="text"
                    name="low_range"
                    value={testFormData.low_range}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Low Range"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    High Range:
                  </label>
                  <input
                    type="text"
                    name="high_range"
                    value={testFormData.high_range}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="High Range"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Mlow Range:
                  </label>
                  <input
                    type="text"
                    name="mlow_range"
                    value={testFormData.mlow_range}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Mlow Range"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Mhigh Range:
                  </label>
                  <input
                    type="text"
                    name="mhigh_range"
                    value={testFormData.mhigh_range}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Mhigh Range"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Flow Range:
                  </label>
                  <input
                    type="text"
                    name="flow_range"
                    value={testFormData.flow_range}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Flow Range"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Fhigh Range:
                  </label>
                  <input
                    type="text"
                    name="fhigh_range"
                    value={testFormData.fhigh_range}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Fhigh Range"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Ilow Range:
                  </label>
                  <input
                    type="text"
                    name="ilow_range"
                    value={testFormData.ilow_range}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Ilow Range"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Ihigh Range:
                  </label>
                  <input
                    type="text"
                    name="ihigh_range"
                    value={testFormData.ihigh_range}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Ihigh Range"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Reference Range Details:
                  </label>
                  <input
                    type="text"
                    name="reference_range_details"
                    value={testFormData.reference_range_details}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Reference Range Details"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Units:
                  </label>
                  <input
                    type="text"
                    name="units"
                    value={testFormData.units}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Units"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <InputOnlyNumber
                  value={testFormData.pt_price}
                  onChange={(e) => handleSetTestFormData(e)}
                  name="pt_price"
                  placeholder="Pt Price"
                  label="Patient Price"
                  fieldName="Patient Price"
                  setInputOnlyNumberError={setInputError}
                />
              </div>
              <div className="col-xl-4">
                <InputOnlyNumber
                  value={testFormData.client_price}
                  onChange={(e) => handleSetTestFormData(e)}
                  name="client_price"
                  placeholder="Client Price"
                  label="Client Price"
                  fieldName="Client Price"
                  setInputOnlyNumberError={setInputError}
                />
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Tax:
                  </label>
                  <input
                    type="number"
                    name="tax"
                    value={testFormData.tax}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Tax"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    TAT:
                  </label>
                  <input
                    type="number"
                    name="tat"
                    value={testFormData.tat}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="TAT"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    Department:
                  </label>
                  <input
                    type="text"
                    name="department"
                    value={testFormData.department}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Department"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="message-text" className="col-form-label">
                    LIS Code:
                  </label>
                  <Select
                    value={{
                      value: testFormData.lisCode,
                      label: testFormData.lisCodeName,
                    }}
                    onChange={(e) => handleSetTestFormData(e, "liscode")}
                    options={
                      liscodes &&
                      liscodes?.map((app) => ({
                        value: app._id,
                        label: app.codeName,
                      }))
                    }
                    styles={{
                      container: (provided) => ({ ...provided, marginTop: 5 }),
                    }}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Analyzer Type:</label>

                  <input
                    type="text"
                    name="analyzerType"
                    value={testFormData.analyzerType}
                    onChange={(e) => handleSetTestFormData(e)}
                    className="form-control"
                    placeholder="Analyzer Type"
                  />
                </div>
              </div>
              <Col xl={4}>
                <div className="form-group position-relative">
                  <label htmlFor="categories" className="col-form-label">
                    Method Name:
                  </label>
                  {testFormData && (
                    <Select
                      value={
                        testFormData.testMethod
                          ? {
                              value: testFormData.testMethod,
                              label: testFormData.testMethodName,
                            }
                          : null
                      }
                      placeholder="Select a Method"
                      onChange={(e) => handleSetTestFormData(e, "testMethod")}
                      options={[
                        {
                          value: null,
                          label: "Select a Method",
                        },
                        ...(testMethod || []).map((item) => ({
                          value: item._id,
                          label: item?.name,
                        })),
                      ]}
                    />
                  )}
                </div>
              </Col>
              <Col xl={4}>
                <div className="form-group position-relative">
                  <label htmlFor="categories" className="col-form-label">
                    Sample Type:
                  </label>
                  {testFormData && (
                    <Select
                      value={
                        testFormData.testSampleType
                          ? {
                              value: testFormData.testSampleType,
                              label: testFormData.testSampleTypeName,
                            }
                          : null
                      }
                      placeholder="Select Sample Type"
                      onChange={(e) =>
                        handleSetTestFormData(e, "testSampleType")
                      }
                      options={[
                        {
                          value: null,
                          label: "Select a Sample Type",
                        },
                        ...(testSampleType || []).map((item) => ({
                          value: item._id,
                          label: item?.name,
                        })),
                      ]}
                      style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: "15px",
                      }}
                    />
                  )}
                </div>
              </Col>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="status" className="col-form-label">
                    Status:
                  </label>
                  <div className="d-flex align-items-center gap-4">
                    {["Active", "Inactive", "Deleted"].map((status) => (
                      <div className="form-check me-3" key={status}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          id={status.toLowerCase()}
                          value={status}
                          checked={testFormData.status === status}
                          onChange={(e) => handleSetTestFormData(e)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={status.toLowerCase()}
                        >
                          {status}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setEditTestModal(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success">
                Update
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default EditTest;
